var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEaBrochuresIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 65 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ea-brochures-icon_svg__a",
    d: "M0 0h60v60H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ea-brochures-icon_svg__c",
    d: "M0 0h61.017v40.678H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ea-brochures-icon_svg__e",
    d: "M0 0h20.34v30.05H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ea-brochures-icon_svg__g",
    d: "M0 60h64.068V0H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.05)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ea-brochures-icon_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ea-brochures-icon_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60 30c0 16.568-13.432 30-30.001 30C13.431 60 0 46.57 0 30 0 13.432 13.432 0 30.001 0 46.569 0 60 13.432 60 30",
    fill: "#F8D7CC",
    mask: "url(#ea-brochures-icon_svg__b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E74A10",
    d: "M60 46.78H36.607l-2.03 2.034H26.44l-2.028-2.034H1.017V10.17H60z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 9.152)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ea-brochures-icon_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ea-brochures-icon_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.862 38.644h7.293l2.03-2.034h22.798V2.034H2.033V36.61h22.8l2.03 2.034zm8.136 2.034h-8.98l-2.029-2.034H0V0h61.018v38.644H37.029l-2.031 2.034z",
    fill: "#020303",
    mask: "url(#ea-brochures-icon_svg__d)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.542 44.746h-2.034V13.22c0-3.305 1.987-6.101 6.102-6.101h18.305v35.593H36.61c-1.97 0-3.305.551-4.068 2.034",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.525 43.729h.44c1.24-1.81 3.215-2.034 4.645-2.034h17.288V8.135H36.61c-3.75 0-5.085 2.627-5.085 5.085V43.73zm1.638 2.034h-3.671V13.22c0-4.258 2.86-7.118 7.118-7.118h19.322v37.627H36.61c-2.11 0-2.767.712-3.164 1.482l-.283.552z",
    fill: "#020303"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.475 44.746h2.033V13.22c0-3.305-1.987-6.101-6.101-6.101H6.102v35.593h18.305c1.97 0 3.305.551 4.068 2.034",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.051 43.729h.44V13.22c0-2.458-1.335-5.084-5.084-5.084H7.119v33.559h17.288c1.43 0 3.404.225 4.644 2.034zm2.474 2.034h-3.67l-.285-.552c-.396-.77-1.053-1.482-3.163-1.482H5.085V6.102h19.322c4.258 0 7.118 2.86 7.118 7.118v32.543z",
    fill: "#020303"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.798 44.688L44.746 31.526v22.312c.013.675.54.908 1.08.384l5.047-4.896 4.878 8.616c.412.671 1.376.818 2.155.327l2.04-1.284c.764-.481 1.067-1.398.683-2.07l-4.697-8.135h6.146c.78-.119 1.311-1.698.72-2.092",
    fill: "#E8E9EA"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(43.729 29.525)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ea-brochures-icon_svg__f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ea-brochures-icon_svg__e"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.381 18.155l5.526 9.762c.017.027.08.066.169.087.17.04.377-.004.56-.12l2.04-1.284c.312-.198.439-.536.342-.705l-5.576-9.657h7.69c.07-.09.139-.254.164-.38L2.034 4v19.337l5.347-5.183zM13.2 30.05c-.198 0-.396-.022-.587-.066a2.308 2.308 0 01-1.458-1.037l-4.247-7.5-4.102 3.979c-.553.538-1.243.71-1.843.464-.588-.243-.948-.825-.963-1.558V0l19.657 14.332c.575.399.806 1.139.619 1.989-.19.86-.812 1.792-1.772 1.94l-.154.01h-4.385l3.816 6.61c.66 1.156.21 2.664-1.022 3.44l-2.04 1.284a2.862 2.862 0 01-1.519.446z",
    fill: "#020303",
    mask: "url(#ea-brochures-icon_svg__f)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E9EA",
    d: "M43.729 26.441v-4.068"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ea-brochures-icon_svg__h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ea-brochures-icon_svg__g"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E9EA",
    mask: "url(#ea-brochures-icon_svg__h)",
    d: "M42.712 26.44h2.034v-4.067h-2.034zM40.952 26.717l-1.8-3.118M40.07 27.225l-1.8-3.118 1.762-1.017 1.8 3.118zM38.92 28.748l-3.118-1.8M38.412 29.629l-3.118-1.8 1.017-1.762 3.118 1.8zM38.644 31.525h-4.068M34.576 32.542h4.068v-2.034h-4.068zM46.502 26.717l1.8-3.118M47.383 27.225l-1.762-1.017 1.8-3.118 1.763 1.017zM38.92 34.307l-3.118 1.8M36.31 36.989l-1.016-1.762 3.118-1.8 1.017 1.76z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.475 44.746h2.033V13.22c0-3.305-1.396-6.637-4.638-7.749L11.186 1.078v35.593l14.684 4.393c1.778.694 2.223 1.966 2.605 3.682",
    fill: "#FEFEFE",
    mask: "url(#ea-brochures-icon_svg__h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.273 43.729h.219V13.22c0-1.274-.285-5.53-3.951-6.787l-13.337-3.99v33.47L26.16 40.09c2.005.778 2.7 2.133 3.112 3.639m1.236 2.034h-2.034c-.477 0-.89-.33-.993-.797-.374-1.684-.732-2.467-1.982-2.954l-14.605-4.367a1.018 1.018 0 01-.725-.974V1.078c0-.322.151-.624.41-.816.258-.193.59-.25.897-.158l14.684 4.393c3.324 1.138 5.365 4.476 5.365 8.723v31.526c0 .562-.456 1.017-1.017 1.017",
    fill: "#020303",
    mask: "url(#ea-brochures-icon_svg__h)"
  }))));
}
export default SvgEaBrochuresIcon;